<template>
  <zg-border
    :border="border"
    :background-color="backgroundColor"
    :border-color="borderColor"
    :flipped-x="flippedX"
    :flipped-y="flippedY"
  />
</template>

<script>
  import ZgBorder from '../../ZgBorder/ZgBorder.vue'

  export default {
    name: 'ZgBorderModule',
    components: {
      ZgBorder
    },
    props: {
      border: {
        type: String,
        required: false,
        default: null
      },
      backgroundColor: {
        type: String,
        required: false,
        default: null
      },
      borderColor: {
        type: String,
        required: false,
        default: null
      },
      flippedX: {
        type: Boolean,
        required: false,
        default: false
      },
      flippedY: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>
